export const appShellPtBr = {
  forbidden: {
    title: 'Acesso negado',
    description:
      'Você não tem permissão para acessar esta página. Entre em contato com o administrador se acredita que isso é um erro.',
    backToDashboard: 'Voltar ao painel',
  },
  routes: {
    titles: {
      dashboard: 'Laboratório',
      agentRuns: 'Execuções do agente',
      mcpCatalog: 'Catálogo MCP',
      mcpWriteConfirmations: 'Aprovações do assistente',
      mcpWriteConfirmationReview: 'Revisar alteração do assistente',
      managerDashboard: 'Painel do gestor',
      chartOfAccounts: 'Plano de contas',
      glLedger: 'Razão',
      glManualEntries: 'Lançamentos manuais',
      glManualEntryNew: 'Novo lançamento manual',
      glManualEntryDetail: 'Lançamento manual',
      glOriginLink: 'Vínculos de origem',
      glGeneralLedger: 'Lançamentos',
      glTrialBalance: 'Balancete',
      balanceSheet: 'Balanço patrimonial',
      cashFlow: 'Fluxo de caixa',
      cashFlowMonthly: 'Fluxo de caixa mensal',
      budget: 'Orçamento',
      fpa: 'DRE',
      fpaHeadcount: 'Plano de Contratações',
      fpaReport: 'FP&A — DRE',
      fpaForecastRuleSets: 'FP&A — Regras de previsão',
      fpaTemplateNew: 'Novo template de DRE',
      fpaTemplateBuilder: 'Construtor de DRE',
      fpaModelagem: 'FP&A — Modelagem',
      arInvoices: 'Contas a receber',
      arEmittedNfs: 'Notas fiscais emitidas',
      arDebitNotes: 'Notas de débito',
      arPreBilling: 'Pré-faturamento',
      arCustomers: 'Clientes',
      arCustomersNew: 'Novo cliente',
      arReceipts: 'Recebimentos',
      billingGroups: 'Grupos de cobrança',
      billingGroupsNew: 'Novo grupo de cobrança',
      billingRevenueCycles: 'Ciclos de receita',
      billingRevenueCyclesNew: 'Novo ciclo de receita',
      billingArForecast: 'Previsão de recebimentos',
      billingServices: 'Serviços de faturamento',
      billingServicesNew: 'Novo serviço',
      billingCostServices: 'Serviços de custo',
      billingCostServicesNew: 'Novo serviço de custo',
      billingCostProvisions: 'Custos provisionados',
      billingCostProvisionsAging: 'Envelhecimento das provisões',
      billingContractTemplates: 'Templates de contrato',
      billingContractTemplatesNew: 'Novo template de contrato',
      billingContracts: 'Contratos',
      billingContractsNew: 'Novo contrato',
      billingContractsFromTemplate: 'Criar contrato a partir de template',
      billingSaasMetrics: 'Métricas SaaS',
      hcmEmployees: 'Colaboradores',
      hcmPayrollRuns: 'Folha de pagamento',
      apBills: 'Contas a pagar',
      apRecurringDashboard: 'Contas recorrentes',
      apDeferralsDashboard: 'Diferimentos',
      apExpenseAccruals: 'Provisões de despesa',
      apExpenseAccrualsReview: 'Revisão de provisões',
      apExpenseAccrualPropose: 'Nova provisão de despesa',
      apPayments: 'Pagamentos',
      apPaymentsNeedsReview: 'Pagamentos em revisão',
      apProcurement: 'Compras',
      apProcurementRequests: 'Requisições de compra',
      apProcurementOrders: 'Pedidos de compra',
      apPurchaseOrderNew: 'Novo pedido de compra',
      apPurchaseRequestNew: 'Nova requisição de compra',
      apVendors: 'Fornecedores',
      apVendorsNew: 'Novo Fornecedor',
      apDocuments: 'Revisão de Documentos',
      apReceivedNfs: 'Notas fiscais recebidas',
      apDdaInbox: 'Caixa de entrada DDA',
      approvalWorkflows: 'Fluxos de aprovação',
      procurementApprovalWorkflows: 'Fluxos de aprovação de requisições',
      reimbursementPolicies: 'Políticas de reembolso',
      reimbursementPoliciesNew: 'Nova política de reembolso',
      reimbursementPolicy: 'Política de reembolso',
      procurementSettings: 'Configurações de compras',
      reimbursementCategories: 'Categorias de reembolso',
      reimbursementPublicLinks: 'Links públicos de reembolso',
      reimbursementRequestNew: 'Nova solicitação de reembolso',
      contractReviewList: 'Revisão de contratos',
      contractReviewSettings: 'Configurações — revisão de contratos',
      contractReviewNew: 'Nova revisão de contrato',
      users: 'Usuários',
      usersNew: 'Novo Usuário',
      invitations: 'Convites',
      roles: 'Papéis',
      rolesNew: 'Novo Papel',
      permissions: 'Permissões',
      changePassword: 'Alterar senha',
      account: 'Minha conta',
      tenants: 'Organizações',
      auditLogs: 'Logs de auditoria',
      ingestionPolicies: 'Políticas de Ingestão',
      approvers: 'Aprovadores',
      classificationRules: 'Regras de classificação',
      classificationRulesNew: 'Nova Regra de Classificação',
      approvalSettings: 'Configurações de aprovação',
      customFields: 'Campos customizados',
      departments: 'Departamentos',
      entities: 'Entidades',
      entitiesNew: 'Nova entidade',
      costCenters: 'Centros de custos',
      departmentsCanvas: 'Relações (Canvas)',
      managerialAccounts: 'Contas gerenciais',
      themes: 'Temas',
      books: 'Livros contábeis',
      booksNew: 'Novo livro contábil',
      calendars: 'Calendários contábeis',
      calendarsNew: 'Novo calendário contábil',
      periods: 'Períodos contábeis',
      periodPlanning: 'Planejamento de períodos',
      rollups: 'Agrupamentos',
      bankAccounts: 'Contas bancárias',
      bankAccountsNew: 'Nova conta bancária',
      creditCards: 'Cartões de crédito',
      creditCardsNew: 'Novo cartão de crédito',
      cardFastTrack: 'Conciliação rápida - Cartão',
      investments: 'Investimentos',
      loans: 'Empréstimos',
      closingChecklist: 'Checklist de fechamento',
      closingCustomTasks: 'Tarefas customizadas',
      closingAiPostings: 'Postagens contábeis a revisar',
      multicurrencyOperations: 'Operações multimoeda',
      assetReviewQueue: 'Fila de revisão de ativos',
      assets: 'Ativos imobilizados',
      newFixedAsset: 'Novo ativo imobilizado',
      leaseContracts: 'Contratos de arrendamento',
      newLeaseContract: 'Novo arrendamento',
      intangibleProjects: 'Intangíveis',
      assetRules: 'Regras de ativos',
      assetOnboarding: 'Configuração inicial de ativos',
      reconciliationInbox: 'Conciliação Bancária',
      reconciliationQueue: 'Conciliação bancária v2',
      reconciliationReview: 'Revisar conciliação',
      reconciliationWorkbench: 'Workbench de Conciliação',
      globalSettings: 'Configurações globais',
      fiscalAutomation: 'Automação fiscal',
      fiscalRegimeAliquotas: 'Regime & Alíquotas',
      accountMapping: 'Mapeamento de contas',
      statutoryTreatment: 'Tratamento de guias',
      revenueTaxRules: 'Tributos sobre receita',
      fiscalAccountMapping: 'Mapeamento Contábil',
      systemAccountMapping: 'Contas do sistema',
      integrations: 'Integrações',
      dimensionReconciliation: 'Mapeamento de integrações',
      preferences: 'Preferências',
    },
    breadcrumbs: {
      fpa: 'FP&A',
      accounting: 'Contabilidade',
      assets: 'Ativos',
      leaseContracts: 'Contratos de arrendamento',
    },
    subtitles: {
      account: 'Perfil, preferências e segurança da sua sessão',
      assetReviewQueue:
        'Compras classificadas como candidatas a imobilizado. Cada linha mostra a regra que ' +
        'decidiu e o número que a acionou.',
      assets: 'Imobilizado e direito de uso, com a régua de depreciação de cada livro ativo.',
      newFixedAsset:
        'Cadastro manual de um bem que o módulo não criou. O caminho normal é a fila de revisão, ' +
        'que amarra o ativo à NF-e.',
      leaseContracts: 'Direito de uso sob o CPC 06 (R2), com o tratamento de cada livro.',
      newLeaseContract:
        'Classificação CPC 06 R2 §5, valor presente e o lançamento de reconhecimento, ' +
        'calculados enquanto você preenche.',
      intangibleProjects:
        'Projetos de desenvolvimento sob o CPC 04, os intangíveis já em uso e a alocação ' +
        'mensal das pessoas que os constroem.',
      assetRules:
        'As regras, os limites e as vidas úteis que decidem o que vira bem e como ele ' +
        'deprecia. O que você mudar aqui vale para as próximas notas.',
      assetOnboarding:
        'Prepare livros, contas, réguas por classe e a política da empresa sem bloquear o módulo.',
      mcpCatalog: 'Consulte as ferramentas disponíveis e como cada uma pode ser usada.',
      customFields: 'Gerencie os campos adicionais para suas contas a pagar.',
      documents: 'Revise e valide documentos extraídos automaticamente.',
      investments:
        'Posição consolidada por tipo e subtipo. Clique em um ativo para ver detalhes e transações.',
      loans: 'Contratos de crédito sincronizados via Open Finance, agrupados por tipo.',
      reconciliationInbox:
        'Reconcilie transações bancárias, de cartão e de investimento com contas a pagar e a receber.',
      reconciliationQueue:
        'Fila de decisões: confirme, resolva diferenças, revise e identifique movimentos do extrato.',
      reconciliationWorkbench:
        'Selecione e vincule transações com suas contas a pagar e realize ajustes.',
      reconciliationReview:
        'Revise e confirme o vínculo entre transações e contas a pagar ou receber.',
      globalSettings: 'Contexto do negócio para orientar classificações e categorias.',
      integrations: 'Conecte ferramentas externas para automatizar processos e sincronizar dados.',
      dimensionReconciliation: 'Mapeie dimensões internas com integrações externas.',
      hcmEmployees: 'Gerencie os colaboradores da empresa.',
      apDdaInbox:
        'Boletos que o banco lista contra a empresa. A busca guarda. Vincular usa uma conta a pagar que já existe.',
    },
    dynamicTitles: {
      agentRunDetail: 'Execução do agente',
      billingCostServiceDetail: 'Serviço de custo',
      billingCostProvisionDetail: 'Provisão de custo',
      mcpWriteConfirmationReview: 'Revisar alteração do assistente',
      glManualEntryDetail: 'Lançamento manual',
      fpaReport: 'Relatório FP&A',
      fpaTemplateNew: 'Novo template de DRE',
      fpaTemplateBuilder: 'Construtor de DRE',
      fpaModelagem: 'FP&A — Modelagem',
      editVendor: 'Editar Fornecedor',
      editArCustomer: 'Editar cliente',
      editFixedAssetDraft: 'Editar rascunho de ativo',
      editUser: 'Editar Usuário',
      editRole: 'Editar Papel',
      approvalWorkflow: 'Fluxo de aprovação',
      classificationRule: 'Regra de classificação',
      tenantDetails: 'Detalhes da Organização',
      editBook: 'Editar livro contábil',
      editBillingService: 'Editar serviço',
      editBillingContractTemplate: 'Editar template de contrato',
      editBillingContract: 'Editar contrato',
      editBillingGroup: 'Editar grupo de cobrança',
      editBillingRevenueCycle: 'Editar ciclo de receita',
      editCalendar: 'Editar calendário contábil',
      editPeriod: 'Editar período contábil',
      editBankAccount: 'Editar conta bancária',
      editCreditCard: 'Editar cartão de crédito',
      investmentDetails: 'Detalhes do investimento',
      loanDetails: 'Detalhes do empréstimo',
      editEntity: 'Editar entidade',
      integrationDetails: 'Detalhes da integração',
      arInvoiceDetails: 'Detalhes da fatura',
      arCustomerDetails: 'Detalhes do cliente',
      hcmEmployeeDetails: 'Colaboradores',
      arReceiptDetails: 'Detalhes do recebimento',
      hcmPayrollRunDetails: 'Detalhes da folha de pagamento',
      reconciliationReview: 'Revisar conciliação',
      contractReviewDetail: 'Detalhes da revisão de contrato',
    },
    defaultTitle: 'Alchemy ERP',
  },
  browserTitles: {
    formTypes: {
      bill: 'Conta',
      vendor: 'Fornecedor',
      customer: 'Cliente',
      billingGroup: 'Grupo de cobrança',
      service: 'Serviço',
      contract: 'Contrato',
      contractTemplate: 'Template de contrato',
      bankAccount: 'Conta bancária',
      creditCard: 'Cartão de crédito',
      book: 'Livro contábil',
      calendar: 'Calendário contábil',
      entity: 'Entidade',
      user: 'Usuário',
      role: 'Papel',
      purchaseOrder: 'Pedido de compra',
      purchaseRequest: 'Requisição de compra',
      reimbursementPolicy: 'Política de reembolso',
      reimbursementRequest: 'Solicitação de reembolso',
      contractReview: 'Revisão de contrato',
      classificationRule: 'Regra de classificação',
    },
  },
  comingSoonPages: {
    backToDashboard: 'Voltar ao painel',
    reportsBudget: {
      title: 'Orçamento',
      description:
        'Planejamento e acompanhamento orçamentário ainda não estão disponíveis nesta versão. Esta tela será habilitada quando o módulo for liberado.',
    },
    reportsCustom: {
      title: 'Reports customizados',
      description:
        'Construtor de relatórios personalizados e biblioteca de modelos virão em breve. Enquanto isso, utilize os relatórios padrão do menu Relatórios.',
    },
    settingsUsersPermissions: {
      title: 'Usuários & permissões',
      description:
        'A central unificada de usuários, papéis e permissões ainda está em construção. Continue usando os atalhos em Identidade & acesso pelo menu ou pela busca (Ctrl/Cmd + K).',
    },
  },
  loading: 'Carregando...',
};

export const appShellEn = {
  forbidden: {
    title: 'Access denied',
    description:
      "You don't have permission to access this page. Contact your administrator if you think this is a mistake.",
    backToDashboard: 'Back to dashboard',
  },
  routes: {
    titles: {
      dashboard: 'Laboratory',
      agentRuns: 'Agent runs',
      mcpWriteConfirmations: 'Assistant approvals',
      mcpWriteConfirmationReview: 'Review assistant change',
      managerDashboard: 'Manager dashboard',
      chartOfAccounts: 'Chart of accounts',
      glLedger: 'Ledger',
      glManualEntries: 'Manual entries',
      glManualEntryNew: 'New manual entry',
      glManualEntryDetail: 'Manual entry',
      glOriginLink: 'Origin links',
      glGeneralLedger: 'Journals',
      glTrialBalance: 'Trial balance',
      balanceSheet: 'Balance sheet',
      cashFlow: 'Cash flow',
      cashFlowMonthly: 'Monthly cash flow',
      budget: 'Budget',
      fpa: 'DRE',
      fpaHeadcount: 'Hiring plan',
      fpaReport: 'FP&A — DRE',
      fpaForecastRuleSets: 'FP&A — Forecast rules',
      fpaTemplateNew: 'New P&L template',
      fpaTemplateBuilder: 'P&L template builder',
      fpaModelagem: 'FP&A — Modeling',
      arInvoices: 'Accounts receivable',
      arEmittedNfs: 'Issued fiscal documents',
      arDebitNotes: 'Debit notes',
      arPreBilling: 'Pre-Billing',
      arCustomers: 'Customers',
      arCustomersNew: 'New customer',
      arReceipts: 'Receipts',
      billingGroups: 'Billing groups',
      billingGroupsNew: 'New billing group',
      billingRevenueCycles: 'Revenue cycles',
      billingRevenueCyclesNew: 'New revenue cycle',
      billingArForecast: 'AR forecast',
      billingServices: 'Billing services',
      billingServicesNew: 'New service',
      billingCostServices: 'Cost services',
      billingCostServicesNew: 'New cost service',
      billingCostProvisions: 'Provisioned costs',
      billingCostProvisionsAging: 'Provision aging',
      billingContractTemplates: 'Contract templates',
      billingContractTemplatesNew: 'New contract template',
      billingContracts: 'Contracts',
      billingContractsNew: 'New contract',
      billingContractsFromTemplate: 'Create contract from template',
      billingSaasMetrics: 'SaaS metrics',
      hcmEmployees: 'Employees',
      hcmPayrollRuns: 'Payroll runs',
      apBills: 'Accounts payable',
      apRecurringDashboard: 'Recurring bills',
      apDeferralsDashboard: 'Deferrals',
      apExpenseAccruals: 'Expense accruals',
      apExpenseAccrualsReview: 'Accrual review',
      apExpenseAccrualPropose: 'New expense accrual',
      apPayments: 'Payments',
      apPaymentsNeedsReview: 'Payments under review',
      apProcurement: 'Procurement',
      apProcurementRequests: 'Purchase requests',
      apProcurementOrders: 'Purchase orders',
      apPurchaseOrderNew: 'New purchase order',
      apPurchaseRequestNew: 'New purchase request',
      apVendors: 'Vendors',
      apVendorsNew: 'New vendor',
      apDocuments: 'Document review',
      apReceivedNfs: 'Received fiscal documents',
      apDdaInbox: 'DDA inbox',
      approvalWorkflows: 'Approval workflows',
      procurementApprovalWorkflows: 'Purchase request approval workflows',
      reimbursementPolicies: 'Reimbursement policies',
      reimbursementPoliciesNew: 'New reimbursement policy',
      reimbursementPolicy: 'Reimbursement policy',
      procurementSettings: 'Procurement settings',
      reimbursementCategories: 'Reimbursement categories',
      reimbursementPublicLinks: 'Reimbursement public links',
      reimbursementRequestNew: 'New reimbursement request',
      contractReviewList: 'Contract reviews',
      contractReviewSettings: 'Contract review settings',
      contractReviewNew: 'New contract review',
      users: 'Users',
      usersNew: 'New user',
      invitations: 'Invitations',
      roles: 'Roles',
      rolesNew: 'New role',
      permissions: 'Permissions',
      changePassword: 'Change password',
      account: 'My account',
      tenants: 'Tenants',
      auditLogs: 'Audit logs',
      ingestionPolicies: 'Ingestion policies',
      approvers: 'Approvers',
      classificationRules: 'Classification rules',
      classificationRulesNew: 'New classification rule',
      approvalSettings: 'Approval settings',
      customFields: 'Custom fields',
      departments: 'Departments',
      entities: 'Entities',
      entitiesNew: 'New entity',
      costCenters: 'Cost centers',
      departmentsCanvas: 'Relationships (Canvas)',
      managerialAccounts: 'Managerial accounts',
      themes: 'Themes',
      books: 'Accounting books',
      booksNew: 'New accounting book',
      calendars: 'Accounting calendars',
      calendarsNew: 'New accounting calendar',
      periods: 'Accounting periods',
      periodPlanning: 'Period planning',
      rollups: 'Rollups',
      bankAccounts: 'Bank accounts',
      bankAccountsNew: 'New bank account',
      creditCards: 'Credit cards',
      creditCardsNew: 'New credit card',
      cardFastTrack: 'Card fast-track reconciliation',
      investments: 'Investments',
      loans: 'Loans',
      closingChecklist: 'Closing checklist',
      closingCustomTasks: 'Custom tasks',
      closingAiPostings: 'Accounting postings to review',
      multicurrencyOperations: 'Multicurrency operations',
      assetReviewQueue: 'Asset review queue',
      assets: 'Fixed assets',
      newFixedAsset: 'New fixed asset',
      leaseContracts: 'Lease contracts',
      newLeaseContract: 'New lease',
      intangibleProjects: 'Intangibles',
      assetRules: 'Asset rules',
      assetOnboarding: 'Asset module setup',
      reconciliationInbox: 'Bank reconciliation',
      reconciliationQueue: 'Bank reconciliation v2',
      reconciliationReview: 'Review reconciliation',
      reconciliationWorkbench: 'Reconciliation workbench',
      globalSettings: 'Global settings',
      fiscalAutomation: 'Fiscal automation',
      fiscalRegimeAliquotas: 'Regime & Rates',
      accountMapping: 'Account mapping',
      statutoryTreatment: 'Tax slip treatment',
      revenueTaxRules: 'Revenue taxes',
      fiscalAccountMapping: 'Account Mapping',
      systemAccountMapping: 'System accounts',
      integrations: 'Integrations',
      dimensionReconciliation: 'Integration mapping',
      preferences: 'Preferences',
    },
    breadcrumbs: {
      fpa: 'FP&A',
      accounting: 'Accounting',
      assets: 'Assets',
      leaseContracts: 'Lease contracts',
    },
    subtitles: {
      account: 'Profile, preferences, and session security',
      assetReviewQueue:
        'Purchases classified as capitalisation candidates. Each row shows the rule that ' +
        'decided and the number that drove it.',
      assets: 'Fixed and right-of-use assets, with the depreciation régua of each active book.',
      newFixedAsset:
        'Hand-register an asset the module did not create. The normal path is the review queue, ' +
        'which links the asset to its NF-e.',
      leaseContracts: 'Right of use under CPC 06 (R2), with each book’s treatment.',
      newLeaseContract:
        'CPC 06 R2 §5 classification, present value and the recognition entry, computed as ' +
        'you type.',
      intangibleProjects:
        'CPC 04 development projects, the intangibles already in service, and the monthly ' +
        'allocation of the people who build them.',
      assetRules:
        'The rules, thresholds and useful lives that decide what becomes an asset and how it ' +
        'depreciates. What you change here applies to the next invoices.',
      assetOnboarding:
        'Prepare books, accounts, class schedules and company policy without blocking the module.',
      mcpCatalog: 'Browse available tools and learn how each one can be used.',
      customFields: 'Manage additional fields for your accounts payable.',
      documents: 'Review and validate automatically extracted documents.',
      investments:
        'Consolidated position by type and subtype. Click an asset for details and transactions.',
      loans: 'Credit contracts synced via Open Finance, grouped by product type.',
      reconciliationInbox:
        'Reconcile bank, card, and investment transactions with accounts payable and receivable.',
      reconciliationQueue:
        'Decision queue: confirm, resolve differences, review and identify statement movements.',
      reconciliationWorkbench:
        'Select and link transactions to accounts payable and apply adjustments.',
      reconciliationReview:
        'Review and confirm the link between transactions and accounts payable or receivable.',
      globalSettings: 'Business context used to orient classifications and categories.',
      integrations: 'Connect external tools to automate processes and sync data.',
      dimensionReconciliation: 'Map internal dimensions to external integrations.',
      hcmEmployees: 'Manage company employees.',
      apDdaInbox:
        'Boletos the bank lists against the company. Fetch stores them. Linking uses a bill that already exists.',
    },
    dynamicTitles: {
      agentRunDetail: 'Agent run',
      billingCostServiceDetail: 'Cost service',
      billingCostProvisionDetail: 'Cost provision',
      mcpWriteConfirmationReview: 'Review assistant change',
      glManualEntryDetail: 'Manual entry',
      fpaReport: 'FP&A report',
      fpaTemplateNew: 'New P&L template',
      fpaTemplateBuilder: 'P&L template builder',
      fpaModelagem: 'FP&A — Modeling',
      editVendor: 'Edit vendor',
      editArCustomer: 'Edit customer',
      editFixedAssetDraft: 'Edit asset draft',
      editUser: 'Edit user',
      editRole: 'Edit role',
      approvalWorkflow: 'Approval workflow',
      classificationRule: 'Classification rule',
      tenantDetails: 'Tenant details',
      editBook: 'Edit accounting book',
      editBillingService: 'Edit service',
      editBillingContractTemplate: 'Edit contract template',
      editBillingContract: 'Edit contract',
      editBillingGroup: 'Edit billing group',
      editBillingRevenueCycle: 'Edit revenue cycle',
      editCalendar: 'Edit accounting calendar',
      editPeriod: 'Edit accounting period',
      editBankAccount: 'Edit bank account',
      editCreditCard: 'Edit credit card',
      investmentDetails: 'Investment details',
      loanDetails: 'Loan details',
      editEntity: 'Edit entity',
      integrationDetails: 'Integration details',
      arInvoiceDetails: 'Invoice details',
      arCustomerDetails: 'Customer details',
      hcmEmployeeDetails: 'Employees',
      arReceiptDetails: 'Receipt details',
      hcmPayrollRunDetails: 'Payroll run details',
      reconciliationReview: 'Review reconciliation',
      contractReviewDetail: 'Contract review details',
    },
    defaultTitle: 'Alchemy ERP',
  },
  browserTitles: {
    formTypes: {
      bill: 'Bill',
      vendor: 'Vendor',
      customer: 'Customer',
      billingGroup: 'Billing group',
      service: 'Service',
      contract: 'Contract',
      contractTemplate: 'Contract template',
      bankAccount: 'Bank account',
      creditCard: 'Credit card',
      book: 'Accounting book',
      calendar: 'Accounting calendar',
      entity: 'Entity',
      user: 'User',
      role: 'Role',
      purchaseOrder: 'Purchase order',
      purchaseRequest: 'Purchase request',
      reimbursementPolicy: 'Reimbursement policy',
      reimbursementRequest: 'Reimbursement request',
      contractReview: 'Contract review',
      classificationRule: 'Classification rule',
    },
  },
  comingSoonPages: {
    backToDashboard: 'Back to dashboard',
    reportsBudget: {
      title: 'Budget',
      description:
        'Budget planning and tracking are not available in this version yet. This screen will unlock when the module is released.',
    },
    reportsCustom: {
      title: 'Custom reports',
      description:
        'A custom report builder and template library are coming soon. Until then, use the standard reports under Reports.',
    },
    settingsUsersPermissions: {
      title: 'Users & permissions',
      description:
        'A unified hub for users, roles, and permissions is still under construction. Continue using Identity & access shortcuts from search (Ctrl/Cmd + K) or your bookmarks.',
    },
  },
  loading: 'Loading...',
};
